import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import * as React from 'react';
// import { connect } from 'react-redux';
// import { actions } from '../business/log/actions';
// import { Storage } from '../business/auth/actions';
// import { i18n } from 'sx-react-i18n';
import * as Sentry from '@sentry/browser';

class ErrorBoundary extends React.PureComponent<any, any> {

    static getDerivedStateFromError(error: any) {
        // Update state so the next render will show the fallback UI.
        return { 
            hasError: true,
            error 
        };
    }
    constructor(props: any) {
        super(props);
        this.state = { 
            eventId: '',
            hasError: false,
            error: undefined
        };
    }

    componentDidCatch(error: any, info: any) {
        //TODO, lo Error to Server
        console.log('Sono in catch errorBoundary')
        Sentry.withScope((scope) => {
            scope.setExtras(info);
            const eventId = Sentry.captureException(error);
            this.setState({ eventId, info });
          });    
    }

    render() {
        if (this.state.hasError) {

            console.log(this.state.error);
            return (
                <Dialog
                    open={true}
                    maxWidth="lg"
                    // fullWidth={true}
                    // fullScreen={true}
                    // title={'Errore generico'}
                    // message={this.state.error.message}
                    // severity={3} /* error */ 
                    // handleConfirm={() => {  window.location.href = '/'; }}
                >
                    <DialogTitle id="simple-dialog-title">Errore Imprevisto</DialogTitle>
                    <DialogContent>
                        <div>
                            {this.state.error.message}
                        </div>
                    </DialogContent> 
                    <DialogActions>
                        <Button id="btnOK" onClick={() => {  window.location.href = '/'; }} variant="contained" color="primary">
                            OK
                        </Button>
                    </DialogActions>                   
                </Dialog>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;